import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import bookSlides from "../../../data/bookSlides";
import { Link } from "react-router-dom";

const BookHeroSection = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const goToNext = () => {
        setCurrentSlide((prev) => (prev + 1) % bookSlides.length);
    };

    const goToPrev = () => {
        setCurrentSlide((prev) => (prev - 1 + bookSlides.length) % bookSlides.length);
    };

    const visibleBooks = [
        bookSlides[currentSlide % bookSlides.length],
        bookSlides[(currentSlide + 1) % bookSlides.length],
        bookSlides[(currentSlide + 2) % bookSlides.length],
        bookSlides[(currentSlide + 3) % bookSlides.length],
    ];
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % bookSlides.length);
        }, 4500); // 3 segundos

        return () => clearInterval(interval);
    }, []);
    const activeBook = bookSlides[currentSlide % bookSlides.length];

    return (
        <section className="flex items-center overflow-hidden min-h-[45vh] sm:min-h-[50vh] lg:h-[60vh]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative">
                {/* MOBILE: un libro centrado */}
                <div className="flex justify-center sm:hidden">
                    <div className="w-[75%] transition-transform duration-700">
                        <Link to={`/books/${activeBook.id}`}>
                            <Image
                                src={activeBook.image}
                                alt={activeBook.title}
                                className="
                                  w-full
                                  aspect-[3/4]
                                  object-contain
                                  rounded-xl
                                  shadow-xl
                                  p-3
                                "
                            />
                        </Link>
                    </div>
                </div>

                {/* DESKTOP / TABLET: carrusel múltiple */}
                <div className="hidden sm:flex gap-6 justify-center">
                    {visibleBooks.map((book, index) => (
                        <div
                            key={index}
                            className="flex-shrink-0 sm:w-[45%] lg:w-1/4 transition-transform duration-500"
                        >
                            <Link to={`/books/${book.id}`}>
                                <Image
                                    src={book.image}
                                    alt={book.title}
                                    className="
                                        w-full
                                        aspect-[3/4]
                                        object-contain
                                        rounded-xl
                                        shadow-lg
                                        p-2
                                      "
                                />
                            </Link>
                        </div>
                    ))}
                </div>


                {/* Flechas de navegación */}
                <button
                    onClick={goToPrev}
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-black/20 hover:bg-black/40 rounded-full flex items-center justify-center z-20"
                    aria-label="Anterior"
                >
                    <Icon name="ChevronLeft" size={24} className="text-white" />
                </button>
                <button
                    onClick={goToNext}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-black/20 hover:bg-black/40 rounded-full flex items-center justify-center z-20"
                    aria-label="Siguiente"
                >
                    <Icon name="ChevronRight" size={24} className="text-white" />
                </button>
            </div>
        </section>
    );
};

export default BookHeroSection;
